/* global localSettings */

import firebase from './Firebase.js';
import 'firebase/firestore';

let db = firebase.firestore();

// defined in webpack.{prod/dev}.js to determine what settings to use for db (local dev vs. prod)
if (localSettings) {
    db.settings(localSettings);
}

export default db;
